var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_apple",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.375,
    height: 18,
    viewBox: "0 0 15.375 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(7.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M251.194,0a4.224,4.224,0,0,0-2.735,1.48,3.669,3.669,0,0,0-.9,2.851,3.565,3.565,0,0,0,2.76-1.41A3.96,3.96,0,0,0,251.194,0Z",
    transform: "translate(-247.522)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(0 4.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M52.19,121.666a4.557,4.557,0,0,0-3.439-1.826c-1.614,0-2.3.773-3.419.773-1.156,0-2.035-.771-3.431-.771a4.669,4.669,0,0,0-3.757,2.271c-1.3,2.018-1.079,5.813,1.03,9.045.755,1.157,1.763,2.457,3.081,2.468,1.173.011,1.5-.753,3.094-.761s1.891.771,3.062.758c1.32-.01,2.383-1.451,3.138-2.608a12.97,12.97,0,0,0,1.162-2.182A3.968,3.968,0,0,1,52.19,121.666Z",
    transform: "translate(-37.336 -119.84)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon_apple.f7ede88010b021ee24e7f84357a4200a.svg";
export { ForwardRef as ReactComponent };